import { Navigate } from 'react-router-dom';

/** Legacy route — redirects to unified outstation pricing management */
export default function OutstationTypesPage() {
  return <Navigate to="/transport/outstation-management" replace />;
}
